import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useMenuPermissions } from '../hooks/useMenuPermissions';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles?: string[];
  fallbackPath?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRoles = [],
  fallbackPath
}) => {
  const { user, isAuthenticated } = useAuth();
  const { hasPermission, getHomePage } = useMenuPermissions();
  const location = useLocation();

  // Se não está autenticado, redirecionar para login
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Se não há roles específicas requeridas, permitir acesso
  if (requiredRoles.length === 0) {
    return <>{children}</>;
  }

  // Verificar se o usuário tem permissão
  if (!hasPermission(requiredRoles)) {
    // Redirecionar para a página inicial apropriada
    const homePage = getHomePage();
    const redirectTo = fallbackPath ?? homePage;
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}; 